import { PORTFOLIO_PATH } from '@ping/constants';
import {
  isBusinessLoginSelector,
  isUserAtFormAStepSelector,
  isUserActivityStatusBannedSelector,
  isUserWaitingOrPendingForReviewSelector,
  useUserInformationStore,
  verificationLevelSelector,
  isUserSupportSelector,
} from '@ping/stores/userInformation.store';
import { isNil } from '@ping/utils';
import router from 'next/router';

const skipIndividualComplianceRedirect = () => isBusinessLoginSelector(useUserInformationStore.getState());

/**
 * It redirects non-KYC users to the `/user/portfolio` page.
 * A Business Login is handled by the KYB verification entry instead.
 */
export const forceRedirectNonKycUser = () => {
  return useUserInformationStore.sliceSubscribe(verificationLevelSelector, verificationLevel => {
    if (skipIndividualComplianceRedirect()) {
      return;
    }

    if (!isNil(verificationLevel) && !verificationLevel) {
      router.push(PORTFOLIO_PATH);
    }
  });
};

/**
 * It redirects the users who need to sign FormA to the `/user/portfolio` page
 */
export const forceRedirectFormAUsers = () => {
  return useUserInformationStore.sliceSubscribe(isUserAtFormAStepSelector, isUserAtFormAStep => {
    if (skipIndividualComplianceRedirect()) {
      return;
    }

    if (isUserAtFormAStep) {
      router.push(PORTFOLIO_PATH);
    }
  });
};

/**
 * It redirects the users who need to wait for the review to the `/user/portfolio` page
 */
export const forceRedirectUserActivityWaitingForReview = () => {
  return useUserInformationStore.sliceSubscribe(
    isUserWaitingOrPendingForReviewSelector,
    isUserWaitingOrPendingForReview => {
      if (skipIndividualComplianceRedirect()) {
        return;
      }

      if (isUserWaitingOrPendingForReview) {
        router.push(PORTFOLIO_PATH);
      }
    }
  );
};

/**
 * It redirects the banned users to the `/user/portfolio` page
 */
export const forceRedirectBannedUsers = () => {
  return useUserInformationStore.sliceSubscribe(isUserActivityStatusBannedSelector, isUserBanned => {
    if (skipIndividualComplianceRedirect()) {
      return;
    }

    if (isUserBanned) {
      router.push(PORTFOLIO_PATH);
    }
  });
};

/**
 * It redirects the support users to the `/markets` page
 */
export const forceRedirectSupportUsers = () => {
  return useUserInformationStore.sliceSubscribe(isUserSupportSelector, isUserSupport => {
    if (isUserSupport) {
      router.push('/markets');
    }
  });
};
